// Web Audio API sound effects — no external assets needed.

let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  try {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  } catch { return null; }
  return audioCtx;
}

function tone(freq, duration = 0.15, type = 'sine', volume = 0.15) {
  const ctx = getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, ctx.currentTime);
  gain.gain.setValueAtTime(volume, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);
  osc.connect(gain).connect(ctx.destination);
  osc.start();
  osc.stop(ctx.currentTime + duration);
}

export function playCoinPop() {
  // bright 2-note pop
  tone(800, 0.08, 'square');
  setTimeout(() => tone(1100, 0.1, 'square'), 60);
}

export function playLevelUp() {
  // rising arpeggio
  const notes = [523, 659, 784, 1047]; // C5 E5 G5 C6
  notes.forEach((f, i) => setTimeout(() => tone(f, 0.18, 'triangle', 0.12), i * 110));
}

export function playSuccess() {
  tone(660, 0.1, 'sine');
  setTimeout(() => tone(880, 0.14, 'sine'), 100);
}

export function playError() {
  tone(180, 0.25, 'sawtooth', 0.1);
}

export function playClick() {
  tone(2000, 0.03, 'square', 0.05);
}

if (typeof window !== 'undefined') {
  window.playCoinPop = playCoinPop;
  window.playLevelUp = playLevelUp;
}
